<template lang="html">
  <DialogInputWrapper
    v-if="mode === 'dialog'"
    v-bind="$attrs"
    v-model="localValue"
    hide-details="auto"
    prepend-inner-icon="mdi-calendar-month-outline"
    :input-value="parsedValue"
    :dialog-attrs="{ 'max-width': '400px' }"
    :clearable="clearable"
    :enableTimezone="enableTimezone"
  >
    <template #default="{ on, value }">
      <DateInputDatePicker
        v-on="on"
        full-width
        v-bind="allDatePickerAttrs"
        :value="value"
      />
    </template>
  </DialogInputWrapper>
  <PopoverInputWrapper
    v-else-if="mode === 'popover'"
    v-bind="$attrs"
    v-model="localValue"
    prepend-inner-icon="mdi-calendar-month-outline"
    :input-value="parsedValue"
    :menu-attrs="{ 'max-width': '400px' }"
    :clearable="clearable"
  >
    <DateInputDatePicker
      v-model="localValue"
      full-width
      v-bind="allDatePickerAttrs"
    />
  </PopoverInputWrapper>
  <DateInputDatePicker
    v-else
    v-model="localValue"
    v-bind="allDatePickerAttrs"
  />
</template>

<script>
import { toDate, isValid, startOfDay } from 'date-fns';
import localValue from '@/mixins/localValue';
import { validateLazyDate, safeParseISO } from '@/functions/DateHelpers';
import DialogInputWrapper from './DialogInputWrapper.vue';
import PopoverInputWrapper from './PopoverInputWrapper.vue';
import DateInputDatePicker from './DateInputDatePicker.vue';
import { format } from 'date-fns-tz';

export default {
  mixins: [localValue],
  components: {
    DateInputDatePicker,
    DialogInputWrapper,
    PopoverInputWrapper,
  },
  name: 'DateInput',
  props: {
    value: {
      type: null,
      validator(val) {
        return safeParseISO(val);
      },
    },
    min: {
      type: [Date, Number, String], // lacks support for date range and NULL
      validator(val) {
        return validateLazyDate(val);
      },
      default: null,
    },
    max: {
      type: [Date, Number, String], // lacks support for date range and NULL
      validator(val) {
        return validateLazyDate(val);
      },
      default: null,
    },
    rules: {
      type: Array,
      default: () => [],
    },
    highlightedDates: {
      type: Array,
      default: () => [],
      // example: [new Date(ISODate), new Date(2020, 2, 6), '2021-02-26'
      // TODO: add support for different colors per list, wrap in Collection[{}]
    },
    mode: {
      type: String,
      default: 'dialog',
    },
    datePickerAttrs: {
      type: Object,
      default: () => ({}),
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    enableTimezone: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(newVal) {
        let valToEmit = newVal;
        const date = new Date(valToEmit);

        if (this.enableTimezone && valToEmit && isValid(date))
          valToEmit = format(date, 'yyyy-MM-dd\'T\'HH:mm:ss.SSS\'Z\'', { timeZone: 'UTC' });

        this.$emit('input', valToEmit);
      },
    },
    parsedValue() {
      let date = this.localValue;
      if (!date) return '';
      if (typeof date === 'string' || date instanceof String) {
        date = safeParseISO(date);
      } else {
        date = toDate(date);
      }
      return this.$d(date, 'date.default');
    },
    allDatePickerAttrs() {
      return {
        min: this.min,
        max: this.max,
        highlightedDates: this.highlightedDates,
        ...this.datePickerAttrs,
      };
    },
  },
};
</script>
